module.exports = __webpack_public_path__ + "static/media/step_1.9a81f258.gif";